import { PATREON_URL } from "./club";

/* Chelsea's live schedule, as a rule so the site works the dates out itself.
   Confirmed with the team, Oct 2026:
   - Club (Patreon, members): the 2nd Tuesday of the month and the Thursday
     two days later.
   - YouTube (free): the other Tuesdays of the month, except a 5th Tuesday,
     which is a night off (e.g. Dec 29 over the holidays).
   - Everything at 7 PM Mountain.
   - No live on a night with an in-person event, or on a date in SKIP. */

export type LiveKind = "club" | "youtube";
export type Live = { start: Date; kind: LiveKind; url: string };

export const YOUTUBE_LIVE_URL = "https://www.youtube.com/@afewloosethreads/live";

/** Denver calendar dates (YYYY-MM-DD) with no live, and why. */
export const SKIP: Record<string, string> = {
  "2026-10-20": "Stitches Night Out, in person",
};

const DENVER = "America/Denver";
const LIVE_HOURS = 2;

/** 7 PM Denver time on a given calendar day, as a real instant. */
export function denverEvening(y: number, m: number, d: number) {
  const guess = Date.UTC(y, m, d, 19 + 7); // assume MST (UTC-7)
  const hour = Number(new Intl.DateTimeFormat("en-US", { timeZone: DENVER, hour: "numeric", hourCycle: "h23" }).format(guess));
  return new Date(guess - (hour - 19) * 36e5); // shift an hour during daylight time
}

const key = (y: number, m: number, d: number) => new Date(Date.UTC(y, m, d)).toISOString().slice(0, 10);

/** Every live in a month (m is 0-based and may overflow into the next year). */
export function livesInMonth(year: number, month: number): Live[] {
  const first = new Date(Date.UTC(year, month, 1));
  const y = first.getUTCFullYear(), m = first.getUTCMonth();
  const days = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
  const firstTue = 1 + ((9 - first.getUTCDay()) % 7);
  const out: Live[] = [];
  const add = (d: number, kind: LiveKind) => {
    if (SKIP[key(y, m, d)]) return;
    out.push({ start: denverEvening(y, m, d), kind, url: kind === "club" ? PATREON_URL : YOUTUBE_LIVE_URL });
  };
  for (let n = 1, d = firstTue; d <= days; n++, d += 7) {
    if (n === 2) { add(d, "club"); add(d + 2, "club"); }
    else if (n <= 4) add(d, "youtube");
  }
  return out;
}

/** The next lives that haven't finished yet, soonest first. */
export function upcomingLives(count = 3, kind?: LiveKind, from = new Date()): Live[] {
  const out: Live[] = [];
  for (let k = 0; out.length < count && k < 6; k++) {
    for (const l of livesInMonth(from.getUTCFullYear(), from.getUTCMonth() + k)) {
      if ((!kind || l.kind === kind) && l.start.getTime() + LIVE_HOURS * 36e5 > from.getTime() && out.length < count) out.push(l);
    }
  }
  return out;
}
